import { gql } from '@urql/core';
import React from 'react';
import Image from 'next/image';
import { getClientEnv } from '../../../client/clientEnv';
import { CollegeLocationCardFragment } from '../../../generated/spin-graphql';

gql`
    fragment CollegeLocationCard on espin_college {
        name
        address {
            state
            city
            country
            location
        }
    }
`;

type Props = {
    college: CollegeLocationCardFragment;
};

export const CollegeLocationCard: React.FC<Props> = ({ college }) => {
    const { city, state, country, location } = college.address;

    const width = 400;
    const height = 267;

    let buildParams = `center=${encodeURIComponent(`${city},${state},${country}`)}`;
    buildParams += `&zoom=13&size=${width}x${height}&maptype=roadmap`;
    if (!!location?.coordinates) {
        const [longitude, latitude] = location.coordinates;
        buildParams += `&markers=color:red|${latitude},${longitude}`;
    }
    buildParams += `&key=${getClientEnv().NEXT_PUBLIC_MAPS_KEY}`;

    return (
        <div className="profile-card dark-theme">
            <div className="title-container no-pad">
                <h2 className="title">Location</h2>
                <div className="location">
                    <div className="map-wrapper">
                        <Image
                            objectPosition="center"
                            objectFit="cover"
                            layout="fill"
                            src={`https://maps.googleapis.com/maps/api/staticmap?${buildParams}`}
                            alt={`Map of ${college.name}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
